import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'subscriptionMonths', // Tracks the chosen subscription months value, like 1 or 6
    'fullPriceTable', // A bit of hack to get all prices to the frontend.
    'canPayMonthly' // Defines if the user can pay monthly.
  ]

  //
  // This controller is a quick conversion of a part of settings.coffee into a stimulus controller
  // and thus not very pretty... Except for showing/choosing the current account level, it also
  // enables/disables the upgrade part of the form, which really belongs more to update-subscription-controller.js perhaps.
  //
  connect() {
    // Hidden field that holds the selected account level _outside_ of this controllers scope, so we can use it
    // to set the chosen account level after an ajax update of all the html inside this controller.
    this.accountLevel = document.getElementById('level');
    this.accountForm = $('account-form')
    this.accountFormSubmit = this.accountForm.getElement('input[type="submit"]');
    this.setChosenLevel(this.accountLevel.value);
    this.updateUpgradeForm();
    this.updateBillingMethods();

    // We can only update quick summary toggle prices if they are available.
    if (this.canPayMonthly()) {
      this.updateQuickSummaryTogglePrices(this.accountLevel.value);
    }
  }

  get levelElements() {
    return Array.from(this.element.querySelectorAll('[data-level]'));
  }

  canPayMonthly() {
    if (this.canPayMonthlyTarget.dataset.canPayMonthly == "true") {
      return true
    }

    return false;
  }

  updateQuickSummaryTogglePrices(chosenLevel) {
    // check if these targets exists as there are states in which they do not exist!
    if (this.getSummaryQuickToggleBillingMonthsChoiceSix() === null || this.getSummaryQuickToggleBillingMonthsChoiceOne() === null) {
      return;
    }

    const table = JSON.parse(this.fullPriceTableTarget.dataset.fullPriceTable);

    var label = this.getSummaryQuickToggleBillingMonthsChoiceSix().children[1]
    var splitText = label.textContent.split(/(á|k)/)
    splitText[2] = " " + table[chosenLevel]["six"] + " "
    label.textContent = splitText.join("")

    label = this.getSummaryQuickToggleBillingMonthsChoiceOne().children[1]
    splitText = label.textContent.split(/(á|k)/)
    splitText[2] = " " + table[chosenLevel]["one"] + " "
    label.textContent = splitText.join("")
  }

  getSummaryQuickToggleBillingMonthsChoiceOne() {
    return document.getElementById('summary-quick-toggle-billing-months-choice-one')
  }

  getSummaryQuickToggleBillingMonthsChoiceSix() {
    return document.getElementById('summary-quick-toggle-billing-months-choice-six')
  }

  getBillingMethodInvoiceChoice() {
    return document.getElementById('billing-method-invoice-choice')
  }

  getBillingMethodCardChoice() {
    return document.getElementById('billing-method-card-choice')
  }

  updateBillingMethods() {
    // check if these targets exists as there are states in which they do not exist!
    if (this.getBillingMethodInvoiceChoice() === null || this.getBillingMethodCardChoice() === null) {
      return;
    }

    // Can't use targets as they lay outside this controllers scope.

    if (this.subscriptionMonthsTarget.value == 1) {

      // For accounts which can pay monthly we only want to disable this option. This is because other logic on this page will be confusing if this option is hidden.
      // If the account are not allowed to pay monthly we want to hide it instead.
      if (this.canPayMonthly()) {
        this.getBillingMethodInvoiceChoice().setAttribute('aria-disabled', 'true')
        this.getBillingMethodInvoiceChoice().classList.add("pointer-events-none")
        this.getBillingMethodInvoiceChoice().classList.add("text-gray-300")
      }
      else {
        this.getBillingMethodInvoiceChoice().classList.add('hidden')
      }
    } else {
      // For accounts which can pay monthly we only want to enable this option.
      // If the account are not allowed to pay monthly we want to show it again.
      if (this.canPayMonthly()) {
        this.getBillingMethodInvoiceChoice().setAttribute('aria-disabled', 'false')
        this.getBillingMethodInvoiceChoice().classList.remove("pointer-events-none")
        this.getBillingMethodInvoiceChoice().classList.remove("text-gray-300")
      }
      else {
        this.getBillingMethodInvoiceChoice().classList.remove('hidden')
      }
    }

    // As card is the only allowed method for one month we force the billing method to be card.
    if (this.subscriptionMonthsTarget.value == 1) {
      this.getBillingMethodCardChoice().querySelector('input[type="radio"]').click()

      if (this.canPayMonthly()) {
        this.getSummaryQuickToggleBillingMonthsChoiceOne().querySelector('input[type="radio"]').click()
      }
    }
  }

  changeLevel(event) {
    var chosenItem = event.target.getParent('[data-level]');
    var chosenLevel = chosenItem.dataset.level
    this.setChosenLevel(chosenLevel);
    if (this.canPayMonthly()) {
      this.updateQuickSummaryTogglePrices(chosenLevel)
    }
    this.accountLevel.value = chosenLevel;
    return this.updateUpgradeForm();
  };

  setChosenLevel(level_name) {
    this.levelElements.each(function(item) {
      item.removeClass('current');
      if (item.dataset.level == level_name) {
        item.addClass('current');
      }
    });
  }

  //
  // Basically just enables the upgrade inputs when an account level has been chosen
  //
  updateUpgradeForm() {
    // Show / hide / toggle the client owner form
    var fieldsets = $$('.upgrade-form');
    if (!fieldsets) { return; }
    fieldsets.set('data-active', +(this.accountLevel.value !== 'free'));

    // Toggle the disabled state of the button
    // To see which buttons use keep-disabled, and for what, search for "keep_disabled" with underscore
    if (this.accountFormSubmit.get('data-keep-disabled') !== 'true') {
      return this.accountFormSubmit.disabled = (this.accountLevel.value === 'free' ? true : false);
    }
  };
}
